import { render, staticRenderFns } from "./SidebarReportItemComponent.vue?vue&type=template&id=bfca8ab0&scoped=true&"
import script from "./SidebarReportItemComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarReportItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfca8ab0",
  null
  
)

export default component.exports